module.exports = __webpack_public_path__ + "img/sierras-le_mclarenplus.47e0cb6.png";